import api from "../utils/api";

class DddApi {
  getListSegmentDDD = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get("/v1/dddapi/list_segment", { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  syncSegmentDDD = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post("/v1/dddapi/sync_segment", data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  
  create = (data) => {
    return new Promise((resolve, reject) => {
      return api
        .post("/appointment", data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  update = (id, data) => {
    return new Promise((resolve, reject) => {
      return api
        .put(`/appointment/${id}`, data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  delete = (id) => {
    return new Promise((resolve, reject) => {
      return api
        .delete(`/appointment/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  getDetail = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/appointment/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
}
const dddApi = new DddApi();
export default dddApi;
